import "./App.css";
import {  useNavigate } from "react-router-dom";
import SideBar from "./components/SideBar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
//import { getTokens,onMessageListener } from "./pages/Firebase";
//import { useState } from "react";



import { oktaAuth } from './auth/okta';
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
// import configData from "./config.json";

const theme = createTheme({
  components: {
    MuiTypography: {
      variants: [
        {
          props: {
            variant: "body2",
          },
          style: {
            fontSize: 11,
          },
        },
        {
          props: {
            variant: "body3",
          },
          style: {
            fontSize: 9,
          },
        },
      ],
    },
    MuiAppBar: {
      variants: [
        {
          props: {
            enableColorOnDark: true,
          },
        },
        {
          props: {
            color: "secondary",
          },
        },
      ],
    },
  },
  palette: {
    primary: {
     // main: "#009BE5",
      main: "rgb(30,60,114)",
      darker: "#053e85",
    },
    secondary: {
      main: "rgb(98, 105, 117)",
      dark: "rgb(98, 105, 117)",
      contrastText:'#FFFFFF'
    },
  },
  // typography: {
  //   allVariants: {
  //     fontFamily: "'Montserrat', sans-serif",
  //     // textTransform: 'none',
  //     // fontSize: 16,
  //   },
  // },
});

theme.typography.span = {
  fontSize: '16px',
  [theme.breakpoints.down('lg')]: {
    fontSize: '14px',
  },
};


// const oktaAuth = new OktaAuth({
//   issuer:configData.issuerUrl,
//   clientId: configData.oktaClientID,
//   redirectUri: window.location.origin + '/login/callback',
//   scopes: ['openid', 'profile', 'email']
// })


function App() {

  let navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth,  originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <ThemeProvider theme={theme}>           
        <Security oktaAuth = {oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <SideBar />
        </Security>       
    </ThemeProvider>
  );
}
export default App;
